// Product photo zoom for the PDP.
//
// Primary interaction (mouse/trackpad — pointer: fine): hovering shows a
// magnifying-glass cursor (native zoom-in glyph); clicking the photo toggles
// an in-place zoom that pans to follow the cursor while active, and clicking
// again (or moving the mouse away) exits. Nothing zooms from hover alone —
// the click is the explicit enter/exit action, and the cursor swaps to the
// zoom-out glyph while zoomed so the state is visible before the next click.
//
// Secondary interaction (works everywhere, including touch): the magnifier
// button always opens a full-screen lightbox with the high-res photo — the
// only zoom mechanism on touch devices, where hover/click-to-toggle doesn't
// apply, and still available on desktop for an even closer look.
(function () {
  // Scale factor lives in CSS (.vault-holo-photo-img.is-zoomed) — keep them in sync.
  function initClickZoom(wrap, photo) {
    if (wrap.dataset.clickZoomInit) return;
    wrap.dataset.clickZoomInit = 'true';

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) return;

    if (photo.dataset.zoomSrc) {
      var preload = new Image();
      preload.src = photo.dataset.zoomSrc;
    }

    var zoomed = false;

    function pan(e) {
      var r = wrap.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      photo.style.transformOrigin = x + '% ' + y + '%';
    }

    function enter(e) {
      if (photo.dataset.zoomSrc && photo.src !== photo.dataset.zoomSrc) {
        photo.src = photo.dataset.zoomSrc;
      }
      zoomed = true;
      photo.classList.add('is-zoomed');
      pan(e);
      wrap.addEventListener('mousemove', pan);
    }

    function exit() {
      zoomed = false;
      photo.classList.remove('is-zoomed');
      photo.style.transform = '';
      wrap.removeEventListener('mousemove', pan);
    }

    wrap.addEventListener('click', function (e) {
      if (zoomed) {
        exit();
      } else {
        enter(e);
      }
    });

    wrap.addEventListener('mouseleave', function () {
      if (zoomed) exit();
    });
  }

  function initModal(section, canHover) {
    var modal = section.querySelector('[data-vault-zoom-modal]');
    var trigger = section.querySelector('[data-vault-zoom-trigger]');
    var photo = section.querySelector('.vault-holo-photo-img');
    if (!modal || !trigger || !photo) return;
    if (modal.dataset.zoomInit) return;
    modal.dataset.zoomInit = 'true';

    var modalImg = modal.querySelector('[data-vault-zoom-image]');
    var closers = modal.querySelectorAll('[data-vault-zoom-close]');
    var lastFocused = null;

    function open() {
      var src = photo.dataset.zoomSrc || photo.currentSrc || photo.src;
      modalImg.src = src;
      modalImg.alt = photo.alt || '';
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('vault-zoom-open');
      modal.querySelector('.vault-zoom-modal-close').focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('vault-zoom-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    trigger.addEventListener('click', open);
    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Touch/no-hover devices have no click-to-toggle in-place zoom (see
    // initClickZoom), so tapping the photo itself opens the full modal — the
    // only zoom available there. On fine-pointer devices the photo's click
    // is owned by the in-place toggle instead; the button still opens the
    // modal for an even closer look.
    if (!canHover) {
      photo.addEventListener('click', open);
    }
  }

  function init() {
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    document.querySelectorAll('[data-section]').forEach(function (section) {
      var wrap = section.querySelector('.vault-holo-photo');
      var photo = section.querySelector('.vault-holo-photo-img');
      if (wrap && photo) {
        initClickZoom(wrap, photo);
      }
      if (section.querySelector('[data-vault-zoom-modal]')) {
        initModal(section, canHover);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
